import {
	buffer,
	distinctUntilChanged, filter,
	map,
	mergeAll,
	Observable,
	of,
} from 'rxjs';
import {Constructor, EventManagerMethods} from './types';

export type AggregatePattern = { [key: string]: Constructor<any> }


export type Aggregation = {
	get<A>(event: Constructor<A>): A[];
	has(...events: Constructor<any>[]): boolean;
};

export class AggregateEvent {
	constructor(private pattern: AggregatePattern, private eventBus: EventManagerMethods) {
	}

	public subscribe(handler: (aggregation: Aggregation) => any): void {
		const events = Object.values(this.pattern)
			.map(event => this.eventBus.fromEvent(event).pipe(map(e => ({...e, type: event}))));

		of(...events).pipe(mergeAll(), buffer(onVisibilityChanged.pipe(filter(Boolean)))).subscribe(res => {
			if (!res.length) {
				return;
			}

			const aggregation = {
				get: (event) => res.filter(e => e.type === event).map(e => e.args),
				has: (...events): boolean => res.some((e) => events.includes(e.type)),
			} as Aggregation;
			handler(aggregation);
		});
	}
}

const onVisibilityChanged = new Observable((subscriber) => {
	const isActiveRef = {
		active: false,
	};
	const handler = (e: Event) => {
    switch (e.type) {
      case 'visibilitychange': {
        isActiveRef.active = document.visibilityState === 'visible';
        break;
      }
      case 'focus': {
        isActiveRef.active = true;
        break;
      }
      case 'blur': {
        isActiveRef.active = false;
        break;
      }
    }

		// if (e.type === 'mouseover') {
		// 	isActiveRef.active = true;
		// }
		subscriber.next(isActiveRef.active);
	};
	document.addEventListener('visibilitychange', handler);
	window.addEventListener('focus', handler);
	window.addEventListener('blur', handler);

	return () => {
		document.removeEventListener('visibilitychange', handler);
		window.removeEventListener('focus', handler);
		window.removeEventListener('blur', handler);
	};
}).pipe(distinctUntilChanged());
